if (typeof window.pdCarouselImagesUpdatesonPdp !== 'function') {
  window.pdCarouselImagesUpdatesonPdp = function () {
    const executeFunctionWhenDomIsReady = (callback) => {
      if (document.readyState !== "loading") callback();
      else document.addEventListener("DOMContentLoaded", callback);
    };

    window.carouselImagesUpdatesonPdpBuild = () => {
      document.querySelector('body').dataset.testImageProduct = 'true';
      const containerProduct = document.querySelector('.product__media-container');
    
      if (containerProduct) {
  
        const mobileDevice = window.matchMedia('(max-width: 768px)').matches;
        const desktopDevice = window.matchMedia('(min-width: 769px)').matches;
  
        const changeImage = (bigImage, smallImage) => {
          if (bigImage && smallImage) {
            const productImageMain = containerProduct.querySelectorAll('.product__media-item img')[0];
            const imageThumbnail = containerProduct.querySelectorAll('.product-thumbnails__item img')[0];
            const imageZoom = containerProduct.querySelectorAll('.product__media-item .lightbox-image ')[0];
        
            imageZoom.dataset.pswpSrc = bigImage;
            productImageMain.src = bigImage;
            productImageMain.srcset = bigImage;
        
            imageThumbnail.src = smallImage;
            imageThumbnail.srcset = smallImage;
          }
        }
  
        // Desktop Image
        if (desktopDevice) {
          const imageWithIconsDeskData = containerProduct.dataset.imageIconsDesk;
          const imageWithIconsDeskDataThumbs = containerProduct.dataset.imageIconsDeskThumbs;
  
          changeImage(imageWithIconsDeskData, imageWithIconsDeskDataThumbs);
        }
  
        // Mobile Image
        if (mobileDevice) {
          const imageWithIconsMobData = containerProduct.dataset.imageIconsMob;
          const imageWithIconsMobDataThumbs = containerProduct.dataset.imageIconsMobThumbs;
  
          changeImage(imageWithIconsMobData, imageWithIconsMobDataThumbs);
        }
  
      }
    };
    
    executeFunctionWhenDomIsReady(() => {
      window.carouselImagesUpdatesonPdpBuild();
    });
  };
}